// imports react
import React, { useState } from 'react';

//imports components
import styles from '../styles/plans.module.css';

export function PlanBanner({ header, price, priceAnnual, subtitle, promotion, features, sign, plan, onSignUp, onLicenseChange, textButton, current, paymentType, currency }) {

  const handleSignUpClick = () => {
    if (onSignUp) {
      onSignUp(plan);
    }
  };

  return (
    <div>
      <div className={`${styles.plan}`}>
        <div className={styles.planHeader}>
          <header>
            <h4 className={styles.planTitle}><strong>{header}</strong></h4>
          </header>
        </div>

        <div className={`${styles.planCost} ${styles.textCenter}`}>
          <div>
            <p>
              {currency} <span className={styles.planInst}>
                <span className={styles.red}>{price.split(",")[0]}</span>,{price.split(",")[1]}
              </span>
            </p>
          </div>
        </div>

        <ul className={`${styles.planFeatures} ${styles.resPlan}`}>
        {features.map((feature, index) => (
            <li key={index} style={feature.isDisadvantage ? { textDecoration: 'line-through' } : {}}>
              <i className={`fa ${feature.isDisadvantage ? 'fa-close' : 'fa-check'} ${styles.icon_circle}`} />
              <span dangerouslySetInnerHTML={{ __html: feature.text }} />
            </li>
          ))}
        </ul>

        {plan == 1 ? <p className={styles.description}><a class={styles.downloadModel} href="https://evoktm.com.br/downloads/EvokReport_Modelo.pdf" target="_blank">Clique aqui</a> para acessar o template do report</p>: null}
        {plan == 2 ? <p className={styles.description}>** Minimo de 10 licenças</p>: null}
        
        <div className={styles.planSign}>
          {sign ? (
             <div className={styles.planSign}>
                <div className={styles.planSelect}>
                  <p onClick={handleSignUpClick}>{textButton}</p>
                </div>
              </div>
          ) : (null)}
        </div>
      </div>
    </div>
  );
}
